import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import style from './EmployeeProjectFullView.module.css'
import EmployeeNavBar from "../../Navbar/EmployeeNavbar";
import BreadCrumb from "../../../../components/BreadCrumb/BreadCrumb";

export default function EmployeeProjectFullView() {
    const { projectId, employeeId } = useParams();
    const [project, setProject] = useState({});
    const [error, setError] = useState("");
    const apiurl = process.env.REACT_APP_SERVER_URL;
    const token = localStorage.getItem("token");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch(`${apiurl}/projects/${projectId}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
            }
        })
            .then((res) => res.json())
            .then((data) => {
                setLoading(false);
                setProject(data.projects)
            })
            .catch((err) => {
                setError(err.message)
                setLoading(true)
            });
    }, [projectId, apiurl, token]);

    if (error) return <p className="text-danger">{error}</p>;

    return (
        <>
            <div className={style.fullView}>

                <div className="container  ">
                    <EmployeeNavBar />
                    <div className="mb-3 ps-3">
                        <BreadCrumb
                            link={`/employee-dashboard/${employeeId}`}
                            name="Dashboard"
                            icon={true}
                        />
                        <BreadCrumb
                            link={`/employee-dashboard/${employeeId}/all-projects`}
                            name="All Projects"
                            icon={true}
                        />
                        <BreadCrumb
                            link={`/employee-dashboard/${employeeId}/projects/${projectId}`}
                            name={project.title}
                            icon={false}
                        />
                    </div>

                    <table className="table table-striped table-bordered table-responsive placeholder-glow ">
                        {
                            loading ?
                                <>
                                    <tbody>
                                        {Array.from({ length: 10 }).map((_, idx) => {
                                            return (
                                                <>
                                                    <tr key={idx} >
                                                        <td className=" text-center">
                                                            <span className="w-25 placeholder placeholder-xs"></span>
                                                        </td>
                                                        <td className=" text-center">
                                                            <span className="w-25 placeholder placeholder-xs"></span>
                                                        </td>

                                                    </tr>

                                                </>
                                            )
                                        })}
                                    </tbody>
                                </>
                                :
                                <>
                                    <thead>
                                        <tr>
                                            <th className="w-50 ps-4">Name</th>
                                            <th className=" ps-4">Details</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className=" ps-4">Title</td>
                                            <td className=" ps-4">{project.title}</td>
                                        </tr>
                                        <tr>
                                            <td className=" ps-4">Description</td>
                                            <td className=" ps-4"> {project.description}</td>
                                        </tr>
                                        <tr>
                                            <td className=" ps-4">Platform</td>
                                            <td className=" ps-4"> {project.platform}</td>
                                        </tr>
                                        <tr>
                                            <td className=" ps-4">Team</td>
                                            <td className=" ps-4">{project.team}</td>
                                        </tr>
                                        <tr>
                                            <td className=" ps-4">Type</td>
                                            <td className=" ps-4">{project.type}</td>
                                        </tr>
                                        <tr>
                                            <td className=" ps-4">status</td>
                                            <td className=" ps-4">{project.status}</td>
                                        </tr>
                                        <tr>
                                            <td className=" ps-4">Priority</td>
                                            <td className=" ps-4">{project.priority}</td>
                                        </tr>
                                        <tr>
                                            <td className=" ps-4">Assigned employees</td>
                                            <td className=" ps-4">{Array.isArray(project.employeeId) && project.employeeId.join(', ')}</td>
                                        </tr>
                                        <tr>
                                            <td className=" ps-4">Progress</td>
                                            <td className=" ps-4">{project.percentage}%</td>
                                        </tr>
                                        <tr>
                                            <td className=" ps-4">Created By</td>
                                            <td className=" ps-4">{project.createdBy}</td>
                                        </tr>
                                        <tr>
                                            <td className=" ps-4">Created At:</td>
                                            <td className=" ps-4">{new Date(project.createdAt).toLocaleDateString()}</td>
                                        </tr>
                                        <tr>
                                            <td className=" ps-4">Last Updated</td>
                                            <td className=" ps-4">{new Date(project.updatedAt).toLocaleDateString()}</td>
                                        </tr>
                                    </tbody>
                                </>
                        }

                    </table>
                </div>
            </div>

        </>
    );
}

